<div class="container-fluid print-footer">
  <div class="row mt-2 pt-2 border-top border-print-gray">
    <div class="col">
      <div class="content-box">
        <p class="text-dark">
          {{ 'printFooter.label' | i18next }}
          <br />
          {{ 'printFooter.copyright' | i18next }}
        </p>
        <p>
          <strong class="text-dark">
            {{ 'printFooter.marketOrganizationName' | i18next }}
            <br />
            {{ 'printFooter.serviceHotline' | i18next }}
          </strong>
        </p>
      </div>
    </div>
  </div>
</div>
